/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import _ from 'lodash'
import React from 'react'
// import InfiniteScroll from 'react-infinite-scroller'
import { useTranslation } from 'react-i18next'
// import Link from '../link'
import combineClassNames from '../../helpers/combineClassNames'
import convertItemsToSectionList from '../../helpers/convert-items-to-section-list'
// import IconDropdownArrow from '../../assets/icons/icon_dropdown_arrow.inline.svg'
import SidePanel from '../side-panel'
import Checkbox from '../checkbox'
import MessageScreen from '../message-screen'
import Radio from '../input-radio'
import InputSearch from '../input-search'
import Collapsible from '../collapsible'
// import {
//   useFilter,
// } from '../../hook/use-filter'
import useStyles from './filter-style'

const FilterView = (props) => {
  const {
    refinedFilters,
    onClear,
    onApply,
    onChange,
    data,
    loadingSections,
  } = props
  const { t } = useTranslation()
  const styles = useStyles()

  const buttons = [
    {
      text: t('ui.filter.buttons.clear'),
      onClick: onClear,
      border: true,
      className: combineClassNames([styles.button]),
    },
    {
      text: t('ui.filter.buttons.apply'),
      onClick: onApply,
      className: combineClassNames([styles.button]),
    },
  ]

  const panelProps = {
    buttons,
    ..._.pick(props, [
      'isOpen',
      'onRequestClose',
      'title',
      'position',
    ]),
  }

  // [TODO] add clear button for search

  return (
    <SidePanel
      {...panelProps}
    >
      {
        _.map(
          data,
          ({
            key,
            name,
            data: options = [],
            selectionType = 'multiple', // or 'single'
            // displayType = 'default', // or 'colorOption'
            enableSearch = false,
            getSubSectionTitle = ({ subType }) => (t('ui.filter.sectionTitle', { context: subType })),
            onSearch,
          }) => {
            const optionRefinedFilters = _.get(refinedFilters, key, [])
            const count = _.size(optionRefinedFilters)
            const groupedOptions = convertItemsToSectionList({
              items: options,
              sectionTitle: (option) => {
                const title = getSubSectionTitle(option)
                if (_.isEmpty(title)) {
                  return t('ui.filter.sectionTitle', { context: 'others' })
                }
                return title
              },
            })
            const loading = _.includes(loadingSections, key)
            let contentType = 'default'
            if (loading) {
              contentType = 'loading'
            } else if (_.isEmpty(options)) {
              contentType = 'empty'
            } else {
              contentType = 'default'
            }
            return (
              <Collapsible
                key={key}
                title={(
                  <>
                    {name}
                    {
                      count
                        ? <span className={styles.count}>{` (${_.size(optionRefinedFilters)})`}</span>
                        : null
                    }
                  </>
                )}
                contentInnerClassName={styles.sectionContent}
                extraData={[_.size(groupedOptions), _.join(loadingSections, ', ')]}
              >
                {
                  enableSearch && (
                    <search
                      className={styles.search}
                    >
                      <InputSearch
                        className={styles.searchInput}
                        onSearch={(query) => onSearch({ key, query })}
                      />
                    </search>
                  )
                }
                {
                  contentType === 'empty' && (
                    <MessageScreen
                      className={styles.emptyScreen}
                      message={t('ui.filter.emptyScreen.message')}
                    />
                  )
                }
                {
                  _.map(groupedOptions, (section, sectionIdx) => {
                    const { title, data: sectionOptions } = section
                    const isMultiSection = _.size(groupedOptions) > 1
                    const sectionKey = _.camelCase(_.get(_.first(sectionOptions), 'subType', sectionIdx))
                    return (
                      <section
                        key={`options_group_${key}_${sectionKey}`}
                        className={styles.subSection}
                      >
                        {
                          // Only show section title if there are multiple sections
                          isMultiSection && (
                            <header
                              className={styles.subSectionTitle}
                            >
                              <h2
                                className={styles.subSectionTitleText}
                              >
                                {title}
                              </h2>
                            </header>
                          )
                        }
                        <div
                          className={styles.subSectionOptions}
                        >
                          {
                            contentType === 'loading' && (
                              <div className={styles.containerLoading}>
                                {
                                  _.map(_.times(_.random(4, 8)), (i) => (
                                    <div
                                      key={`loading-block-${i}`}
                                      className={styles.loadingBlock}
                                      style={{ width: `${_.random(30, 80)}%` }}
                                    />
                                  ))
                                }
                              </div>
                            )
                          }
                          {
                            contentType === 'default' && (
                              _.map(sectionOptions, (item) => {
                                switch (selectionType) {
                                  case 'multiple':
                                    return (
                                      <Checkbox
                                        key={`${key}_${item.value}`}
                                        name={`${key}_${item.value}`}
                                        wrapperStyle={styles.checkbox}
                                        labelStyle={styles.checkboxLabel}
                                        checked={_.includes(optionRefinedFilters, item.value)}
                                        onChange={({ nativeEvent }) => {
                                          const checked = _.get(nativeEvent, 'target.checked', false)
                                          if (checked) {
                                            onChange({
                                              key,
                                              values: _.concat(optionRefinedFilters, item.value),
                                            })
                                          } else {
                                            onChange({
                                              key,
                                              values: _.without(optionRefinedFilters, item.value),
                                            })
                                          }
                                        }}
                                      >
                                        {item.name}
                                      </Checkbox>
                                    )
                                  case 'single':
                                    return (
                                      <Radio
                                        name={key}
                                        key={`${key}_${item.value}`}
                                        labelClassName={combineClassNames([
                                          styles.checkbox,
                                          styles.radio,
                                        ])}
                                        checked={_.includes(optionRefinedFilters, item.value)}
                                        onChange={({ nativeEvent }) => {
                                          const checked = _.get(nativeEvent, 'target.checked', false)
                                          if (checked) {
                                            onChange({ key, values: [item.value] })
                                          } else {
                                            onChange({
                                              key,
                                              values: _.without(optionRefinedFilters, item.value),
                                            })
                                          }
                                        }}
                                      >
                                        {item.name}
                                      </Radio>
                                    )
                                  default:
                                    return null
                                }
                              })
                            )
                          }
                        </div>
                      </section>
                    )
                  })
                }
              </Collapsible>
            )
          },
        )
      }
    </SidePanel>
  )
}

export default FilterView
